import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Stepper from "react-stepper-horizontal";
import { CircularProgress } from "@mui/material";

import ServiceLocationPage from "./components/service_location";
import ServiceStep3Page from "./components/service_step3";
import ServiceStep4Page from "./components/service_step4";

import { serviceStore } from "../../actions/serviceAction.js";

import "./service.css";

const ServicePage = ({ serviceStore, service, auth, socket }) => {

  // Restore the step the user was on so a page reload keeps them in place
  // instead of resetting to step 1.
  const [stepperVal, setState] = useState(() => {
    const saved = parseInt(localStorage.getItem("serviceStep"), 10);
    return Number.isInteger(saved) && saved >= 0 && saved <= 2 ? saved : 0;
  });
  const [locationSelected, setLocationSelected] = useState(false);
  const [joinBlocked, setJoinBlocked] = useState(true);
  const [joining, setJoining] = useState(false);

  let locationSaveFn = useRef(null);

  let history = useHistory();

  // Persist the current step across reloads.
  useEffect(() => {
    localStorage.setItem("serviceStep", String(stepperVal));
  }, [stepperVal]);

  // Source of truth for "already onboarded" is the backend flag, not the
  // persisted serviceData (which can hold a stale `flag` from a previous
  // onboarding done in this browser and would wrongly bounce new sign-ups).
  useEffect(() => {
    if (auth.user.isServiceRegisted) {
      localStorage.removeItem("serviceStep");
      history.push("/dashboard");
    }
  }, [auth, history]);

  const handleNext = () => {
    if (stepperVal === 0 && locationSaveFn.current) {
      locationSaveFn.current();
    }
    setState((prev) => Math.min(prev + 1, 2));
  };

  const handleBack = () => {
    setState((prev) => Math.max(prev - 1, 0));
  };

  const handleJoinNow = () => {
    if (joining) return;
    setJoining(true);
    socket.emit("SERVICECREATED", { userId: auth.user.userId });
    serviceStore({
      flag: true,
      navigator: () => {
        localStorage.removeItem("serviceStep");
        history.push("/dashboard");
      },
    });
  };

  // The service step needs a service name + rate filled before advancing.
  const step2Disabled =
    !service.serviceData.serviceName ||
    service.serviceData.serviceName.trim() === "" ||
    !service.serviceData.serviceRate ||
    Number(service.serviceData.serviceRate) === 0;

  let mainPage;
  let buttonDisable = false;
  let showNextBack = true;

  switch (stepperVal) {
    case 0:
      // Step 1: register location. This is the first step, so it has no Back
      // button (see the button row below).
      mainPage = (
        <ServiceLocationPage
          onSave={(fn) => { locationSaveFn.current = fn; }}
          onLocationChange={(val) => setLocationSelected(val)}
        />
      );
      buttonDisable = !locationSelected;
      break;
    case 1:
      mainPage = <ServiceStep3Page />;
      buttonDisable = step2Disabled;
      break;
    case 2:
      mainPage = (
        <ServiceStep4Page
          onValidChange={setJoinBlocked}
        />
      );
      showNextBack = false;
      break;
    default:
      break;
  }

  return (
    <div className="service-form-container">
      <div className="service-form shadow-none">
        <div className="service-form-content">
          <div className="mb-4">
            <Stepper
              steps={[
                { title: "" },
                { title: "" },
                { title: "" },
              ]}
              size={36}
              activeStep={stepperVal}
              completeColor={"#1CC300"}
              activeColor={"#1CC300"}
              defaultColor={"#D9D9D9"}
              circleFontColor={"white"}
              barStyle={"dotted"}
              completeBarColor={"#1CC300"}
            />
          </div>

          {mainPage}

          <div className="grid grid-cols-2">
            <div className="col-span-1">
              {/* No Back button on the first (register location) step. */}
              {stepperVal !== 0 && (
                <button
                  type="button"
                  className="btn btn-success btn-service-back text-white"
                  onClick={handleBack}
                >
                  Back
                </button>
              )}
            </div>
            <div className="col-span-1">
              {stepperVal === 2 ? (
                <button
                  type="button"
                  className="btn btn-success btn-service-next text-white"
                  onClick={handleJoinNow}
                  disabled={joinBlocked || joining}
                >
                  {joining ? (
                    <span className="inline-flex items-center justify-center gap-2">
                      <CircularProgress size={18} sx={{ color: "white" }} />
                      Joining...
                    </span>
                  ) : (
                    "JOIN NOW"
                  )}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-success btn-service-next text-white"
                  onClick={handleNext}
                  disabled={buttonDisable}
                >
                  Next
                </button>
              )}
            </div>
          </div>

          <br />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  service: state.service,
  auth: state.auth,
});
export default connect(mapStateToProps, { serviceStore })(ServicePage);
